// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__30NRp","emails":"CreateEditClinics_emails__2nQ-0","emailTagLabel":"CreateEditClinics_emailTagLabel__1Dsa_"};